import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 MegaPack Agenda Llena (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Kit WhatsApp "Turno Confirmado"',
  price: 'GRATIS'
}, {
  label: '🎁 Planificador Agenda 6 Días',
  price: 'GRATIS'
}, {
  label: '🎁 Checklist Instagram Lash que Vende',
  price: 'GRATIS'
}, {
  label: '🎁 Mini Guía Fotos Lash con Celular',
  price: 'GRATIS'
}, {
  label: '🎁 Workbook Clienta Fija',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="bg-ink-2 border-y border-white/5" data-id="element-170" data-mp="35ov3gb5xzn30">
      <div className="mx-auto max-w-2xl px-5 py-20 text-center pb-[21px] pt-[14px]" data-id="element-171" data-mp="1tetpsck1w9wx">
        <h2 className="font-display text-3xl font-black text-white sm:text-4xl pt-[9px] mt-[-10px] mb-[-10px]" data-id="element-172" data-mp="1oga50fh71465">
          🚀 Empezá a llenar tu agenda desde hoy
        </h2>
        

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-173" data-mp="236zgzk2hanb2">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50 pt-[7px]" data-id="element-174" data-mp="1ycmsuwq24nsz">
            <span data-id="element-175" data-mp="283hkkgm2oflt">Qué incluye</span>
            <span data-id="element-176" data-mp="286lrhlqx9pg6">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between border-b border-white/5 px-5 py-3.5 text-sm pt-[2px]" data-id="element-177" data-mp="2m2pmhh9me1tp">
              <span className="text-white/80 pt-[3px]" data-id="element-178" data-mp="2h34kexz5ldcr">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'font-bold text-white' : 'font-bold text-rose-soft'} data-id="element-179" data-mp="rqj7s8hip2wn">
                {r.price}
              </span>
            </div>)}
          <div className="flex items-center justify-between bg-rose/10 px-5 py-4" data-id="element-180" data-mp="2mtxn9wx4hsfn">
            <span className="text-sm font-bold text-white" data-id="element-181" data-mp="2rrqtur2c8ogg">
              Valor total real: <span className="text-white/40 line-through" data-id="element-182" data-mp="2vtu81nge675f">$101.940</span>
            </span>
            <span className="font-display text-2xl font-black text-white" data-id="element-183" data-mp="2vw6zcr81htv5">$19.990 ARS</span>
          </div>
        </div>

        <div className="mt-9" data-id="element-184" data-mp="35sa3u3qd64l9">
          <CTAButton href="https://megapack-agenda-llena.impultienda.ar/checkout" data-id="element-185" data-mp="35r8ohn2bevxq">Sí, quiero llenar mi agenda</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-186" data-mp="3ap0egbjeg7za">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-187" data-mp="3jix1rtoavqga">
              <Icon className="h-4 w-4 text-gold" data-id="element-188" data-mp="3ojknq0xo9h3n" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}